import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FlexContainer,
  HorizontalTabs,
} from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import SearchInputs from "../../../constants/Orders/SearchInputs.json";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { isValNull } from "../../../utils";
import InitialStates from "./initialState.json";
import { bindActionCreators } from "redux";
import * as OrderActions from "../../../store/actions/Orders";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import { useDispatch } from "react-redux";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import { ORDER_STATE_LIVE } from "../../../constants/Orders/States";

const searchkeys = ["id", "external_order_id", "trip_id", "driver_id", "city_id", "locality_id", "tenant"];

function removeUnrelatedFilters(curFilters, curKey) {
  searchkeys.forEach((searchKey) => {
    if (searchKey !== curKey) {
      if (curKey == 'external_order_id' && searchKey == 'tenant') {
        return;
      } else if((curKey == 'locality_id' || curKey == 'city_id') && (searchKey == 'tenant' || searchKey == 'locality_id' || searchKey == 'city_id')) {
        return;
      } else if(curKey == 'tenant' && (searchKey == 'locality_id' || searchKey == 'city_id' || searchKey == 'external_order_id')) {
        return;
      }
      curFilters[searchKey] = "";
    }
  });
}

export const TENANT_ZOMATO = "ZOMATO";
export const TENANT_BLINKIT = "BLINKIT";
export const TENANT_OTHER = "OTHER";

function parseToRequestFilters(filters) {
  var finalFilter = {};
  const tenantMapping = {
    [TENANT_ZOMATO]: 1,
    [TENANT_BLINKIT]: 2,
    [TENANT_OTHER]: 3
  };
  if (filters.id) {
    finalFilter = {
      baseFilter: {
        order_id: filters.id,
      },
    };
    return finalFilter;
  }
  if (filters.external_order_id) {
    finalFilter = {
      externalOrderIdFilter: {
        external_order_id: filters.external_order_id,
        tenant: tenantMapping[filters.tenant] || 0,
      },
    };
    return finalFilter;
  }
  if (filters.trip_id) {
    finalFilter = {
      tripBaseFilter: {
        trip_id: filters.trip_id,
      },
    };
    return finalFilter;
  }
  if (filters.driver_id) {
    finalFilter = {
      driverIdFilter: {
        driver_id: Number(filters.driver_id),
      },
    };
    return finalFilter;
  }
  if (filters.locality_id) {
    finalFilter = {
      addressFilter: {
        city_ids: [String(filters.city_id)],
        locality_ids: [String(filters.locality_id)],
        tenant: tenantMapping[filters.tenant] || 0,
        order_state: ORDER_STATE_LIVE,
      },
    };
    return finalFilter;
  }
  if (filters.city_id) {
    finalFilter = {
      addressFilter: {
        city_ids: [String(filters.city_id)],
        tenant: tenantMapping[filters.tenant] || 0,
        order_state: ORDER_STATE_LIVE,
      },
    };
    return finalFilter;
  }
  return { error: "No filters present" };
}

const FilterSearchBar = ({ applyFilters, getCityList, nextPageCity, getCity, getLocalityList, nextPageLocality, getLocality,  }) => {
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialState, setInitialState] = useState({ ...InitialStates });
  const [priorityFlagForLocality, setPriorityFlagForLocality] = useState(false);
  const [priorityFlagForCity, setPriorityFlagForCity] = useState(true);
  const [missingFields, setMissingFields] = useState({
    "tenant": false,
  });

  const tenants = [{
    label: "ZOMATO",
    key: "ZOMATO"
  }, {
    label: "BLINKIT",
    key: "BLINKIT"
  }, {
    label: "OTHER",
    key: "OTHER"
  }]

  const handleClick = (index) => (e) => {
    setActiveIndex(index);
  };


  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    if (key === "city_id") {
      if (initialState["tenant"] === "") {
        setMissingFields({
          ...missingFields,
          "tenant": true,
        });
      }

      values["locality_id"] = "";
      setPriorityFlagForLocality(true);
      setPriorityFlagForCity(false);
    } else if (key === "locality_id") {
      if (initialState["tenant"] === "") {
        setMissingFields({
          ...missingFields,
          "tenant": true,
        });
      }

      setPriorityFlagForLocality(false);
    } else if (key === "tenant") {
      setMissingFields({
        ...missingFields,
        "tenant": false,
      });
    } else if(key === "external_order_id") {
        if (initialState["tenant"] === "") {
          setMissingFields({
            ...missingFields,
            "tenant": true,
          });
        }
        setPriorityFlagForCity(true);
    } else if(key === "id" || key === "trip_id" || key === "driver_id") {
       setPriorityFlagForCity(true);
       setMissingFields({
        ...missingFields,
        "tenant": false,
      });
    }

    removeUnrelatedFilters(values, key);
    setInitialState(values);
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();
    var filter;
    filter = parseToRequestFilters(initialState);
    if (filter.error) {
      alert(filter.error);
      return;
    }
    applyFilters(filter);
  };

  const getCount = () => {
    const keys = searchkeys;
    let count = 0;
    keys.forEach((key) => {
      if (!isValNull(initialState[key])) {
        count++;
      }
    });
    return count;
  };

  const checkIfButtonDisabled = (btnType) => {
    if (initialState['external_order_id'] && initialState['tenant'] === "") {
      return true;
    } else if (initialState['city_id'] && initialState['tenant'] === "") {
      return true;
    } else if (initialState['locality_id'] && (initialState['tenant'] === "" || initialState['city_id'] === "")) {
      return true;
    }
    return false;
  };

  return (
    <FilterSearchBox
      className="containsDropdown mr-10"
      onSubmit={(e) => handleSubmit(e, "apply")}
    >
    <HorizontalTabs className="mb-18">
      <HorizontalTabs.Link
        className="searchIndex"
        active={activeIndex === 0}
        onClick={handleClick(0)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <span>
          SEARCH{" "}
          {getCount() > 0 && (
            <sup style={{ color: variables.white }}>({getCount()})</sup>
          )}
        </span>
      </HorizontalTabs.Link>
    </HorizontalTabs>

      <React.Fragment>
        {SearchInputs.inputs.map((field, index) => {
          return (
            <Input
              onChange={(e) => handleChange(field.name, e)}
              value={initialState[field.name]}
              data-testid={`input-field-${field.name}`}
              key={index}
              type={field.isNumber ? "number" : undefined}
              id="sushi-input"
              label={field.label}
            />
          );
        })}

        <Input
          onChange={(e) => handleChange('external_order_id', e)}
          value={initialState.external_order_id}
          data-testid="input-field-external_order_id"
          id="sushi-input"
          label="External Order ID"
        />

        <DropdownWrapper hasError={missingFields["tenant"]}>
          <PaginatedReactDropdown
            options={tenants}
            labelKey="label"
            valueKey="key"
            labelWidth="15%"
            value={initialState.tenant}
            handleChange={handleChange}
            keyToChange="tenant"
            placeholder="Tenant"
            showCross={false}
            id="tenantDropdown"
          />
        </DropdownWrapper>

        <InfiniteScrollDropdown
          id="cityFilterDropdown"
          className="sushi-dropdown"
          priorityFlag={priorityFlagForCity}
          setPriorityFlag={setPriorityFlagForCity}
          appliedFilters={{}}
          getActiveList={getCityList}
          nextPage={nextPageCity}
          resKey="cities"
          keyName="city_id"
          labelKey="city_name"
          getDataLabelKey="city.city_name"
          keyTypeToSet="id"
          label="City"
          handleChange={handleChange}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          activeElement={initialState}
          getActiveItemById={getCity}
        />
        
        {
          initialState.city_id != "" && (
            <InfiniteScrollDropdown
              id="localityFilterDropdown"
              className="sushi-dropdown"
              priorityFlag={priorityFlagForLocality}
              setPriorityFlag={setPriorityFlagForLocality}
              appliedFilters={
                initialState.city_id ? { city_id: initialState.city_id } : {}
              }
              getActiveList={getLocalityList}
              nextPage={nextPageLocality}
              resKey="localities"
              keyName="locality_id"
              labelKey="locality_name"
              getDataLabelKey="locality.locality_name"
              keyTypeToSet="id"
              label="Locality"
              handleChange={handleChange}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeElement={initialState}
              getActiveItemById={getLocality}
            />
          )
        }
      </React.Fragment>

      <FlexContainer>
        <Button
          onClick={(e) => handleSubmit(e, "apply")}
          disabled={checkIfButtonDisabled("apply")}
          className="sushi-btn"
          data-testid="filtersApply"
          type="submit"
        >
          Apply
        </Button>
      </FlexContainer>
    </FilterSearchBox>
  );
};

const FilterSearchBox = styled.form`
  padding: 18px;
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;

  #sushi-input {
    margin-bottom: 14px;
  }

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
    .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    border-radius: 8px;
    padding: 10px 18px;
    box-sizing: border-box;
    height: unset;
  }
  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${variables.grey300};
  }
  .MuiFormLabel-root.Mui-focused {
    color: ${variables.grey700};
  }
  .MuiAutocomplete-popupIndicator {
    margin-right: 8px;
  }
  .cross {
    opacity: 0.5;
    width: 15px;
    height: auto;
    margin-right: 10px;
  }
  .MuiInputLabel-outlined {
    transform: translate(20px, 15px) scale(1);
    &.MuiInputLabel-shrink {
      transform: translate(10px, -8px) scale(0.8);
    }
  }
  .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
    .MuiAutocomplete-input {
    padding: 2px 4px;
  }

  .partner_status_options > div {
    word-break: break-all;
  }
`;

const DropdownWrapper = styled.div`
  ${props => props.hasError && `
    .MuiOutlinedInput-root {
      border: 2px solid #ef4444 !important;
      border-radius: 8px;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }
    // Target PaginatedReactDropdown's custom styles
    .customDropdown {
      border: 2px solid #ef4444 !important;
      border-radius: 8px;
    }
  `}
  margin-bottom: 14px;
  width: 100%;
`;

function mapStateToProps(state) {
  const { City, Locality } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    applyFilters: bindActionCreators(OrderActions.getOrdersList, dispatch),
      getCityList: bindActionCreators(CityActions.getCityList, dispatch),
      getLocalityList: bindActionCreators(
        LocalityActions.getLocalityList,
        dispatch
      ),
      getCity: bindActionCreators(CityActions.getCity, dispatch),
      getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterSearchBar);
